import React, { Fragment, useEffect, useState } from "react";
import IconAlert from "./IconAlert";
import {
    selectLang,
    Translate,
} from "../../app/store/reducers/main/mainReducer";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

const HIDDEN_PATH_PREFIXES = ["/roaming", "/edi"];

const AlertWarhouseToSotuvchi = () => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const location = useLocation();

    const [show, setShow] = useState(false);

    const isHiddenByRoute = HIDDEN_PATH_PREFIXES.some((prefix) =>
        location.pathname.startsWith(prefix)
    );

    useEffect(() => {
        if (isHiddenByRoute) {
            setShow(false);
            return;
        }

        const closedCount = parseInt(
            localStorage.getItem("alert_warhouse_to_sotuvchi_closed_count") || "0",
            10
        );
        const lastClosed = localStorage.getItem("alert_warhouse_to_sotuvchi_closed");
        const now = new Date();

        if (closedCount >= 3) {
            setShow(false);
            return;
        }

        if (!lastClosed) {
            setShow(true);
            return;
        }

        const lastClosedDate = new Date(lastClosed);
        const diffMs = now.getTime() - lastClosedDate.getTime();
        const diffHours = diffMs / (1000 * 60 * 60);

        if (diffHours >= 24) {
            setShow(true);
        }
    }, [isHiddenByRoute]);

    const translatedText1 = t(
        lang,
        "main.common.price_update_alert.notification_text.part.6",
        {
            hippo_uz: "{hippo_uz}",
        }
    );

    const handleClose = () => {
        const closedCount = parseInt(
            localStorage.getItem("alert_warhouse_to_sotuvchi_closed_count") || "0",
            10
        );
        const newCount = closedCount + 1;
        localStorage.setItem(
            "alert_warhouse_to_sotuvchi_closed_count",
            newCount.toString()
        );
        localStorage.setItem(
            "alert_warhouse_to_sotuvchi_closed",
            new Date().toISOString()
        );
        setShow(false);
    };

    return (
        <Fragment>
            {show && (
                <IconAlert variant={"info"} dismissible onClose={handleClose}>
                    <div>
                        <p className={"m-0 fw-bold"}>
                            {t(lang, "main.common.price_update_alert.notification_text")}
                        </p>
                        <p className={"m-0"}>
                            {translatedText1.split(/({hippo_uz})/g).map((part, index) =>
                                part === "{hippo_uz}" ? (
                                    <a
                                        href="https://sotuvchi.hippo.uz/"
                                        target="_blank"
                                        key={index}
                                        className={"fs-0"}
                                    >
                                        sotuvchi.hippo.uz
                                    </a>
                                ) : (
                                    part
                                )
                            )}
                        </p>
                        <p className={"m-0"}>
                            {t(
                                lang,
                                "main.common.price_update_alert.notification_text.part.3"
                            )}
                        </p>
                    </div>
                </IconAlert>
            )}
        </Fragment>
    );
};

export default AlertWarhouseToSotuvchi;
